import { IconContent } from '@icons';

export const squareOnSquare: IconContent = {
    sm: '<path fill-rule="evenodd" d="M13.5 9.5H12V4H6.5V2.5h7v7ZM5.5 4V1.5h9v9H12V14H2V4h3.5Zm5.5 9H3V5h8v8Z"/>',
};
